"use strict";

var _interopRequireDefault = require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/createClass.js"));

var GrowthPlan = /*#__PURE__*/function () {
  function GrowthPlan(client) {
    (0, _classCallCheck2["default"])(this, GrowthPlan);
    this.client = client;
    this.resourceUrl = '/intention';
  }

  (0, _createClass2["default"])(GrowthPlan, [{
    key: "getIntentions",
    value: function getIntentions(data) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return this.client.post("".concat(this.resourceUrl), data, args);
    }
  }, {
    key: "addIntention",
    value: function addIntention(data) {
      var _this$client;

      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      return (_this$client = this.client).post.apply(_this$client, ["".concat(this.resourceUrl, "/add"), data].concat(args));
    }
  }, {
    key: "getIntentionById",
    value: function getIntentionById(id) {
      var _this$client2;

      for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        args[_key3 - 1] = arguments[_key3];
      }

      return (_this$client2 = this.client).get.apply(_this$client2, ["".concat(this.resourceUrl, "/").concat(id)].concat(args));
    }
  }, {
    key: "updateIntention",
    value: function updateIntention(data, intensionId) {
      var _this$client3;

      for (var _len4 = arguments.length, args = new Array(_len4 > 2 ? _len4 - 2 : 0), _key4 = 2; _key4 < _len4; _key4++) {
        args[_key4 - 2] = arguments[_key4];
      }

      return (_this$client3 = this.client).put.apply(_this$client3, ["".concat(this.resourceUrl, "/").concat(intensionId), data].concat(args));
    }
  }, {
    key: "toggleArchive",
    value: function toggleArchive(intensionId, archived) {
      for (var _len5 = arguments.length, args = new Array(_len5 > 2 ? _len5 - 2 : 0), _key5 = 2; _key5 < _len5; _key5++) {
        args[_key5 - 2] = arguments[_key5];
      }

      return this.client.get("".concat(this.resourceUrl, "/").concat(intensionId, "/toggle-archive?archived=").concat(archived), args);
    }
  }, {
    key: "addInsight",
    value: function addInsight(data, id) {
      for (var _len6 = arguments.length, args = new Array(_len6 > 2 ? _len6 - 2 : 0), _key6 = 2; _key6 < _len6; _key6++) {
        args[_key6 - 2] = arguments[_key6];
      }

      return this.client.post("".concat(this.resourceUrl, "/").concat(id, "/insight"), data, args);
    }
  }, {
    key: "updateInsight",
    value: function updateInsight(data, intentionId, insightId) {
      for (var _len7 = arguments.length, args = new Array(_len7 > 3 ? _len7 - 3 : 0), _key7 = 3; _key7 < _len7; _key7++) {
        args[_key7 - 3] = arguments[_key7];
      }

      return this.client.put("".concat(this.resourceUrl, "/").concat(intentionId, "/insight/").concat(insightId), data, args);
    }
  }, {
    key: "deleteIntention",
    value: function deleteIntention(intentionId) {
      var _this$client4;

      for (var _len8 = arguments.length, args = new Array(_len8 > 1 ? _len8 - 1 : 0), _key8 = 1; _key8 < _len8; _key8++) {
        args[_key8 - 1] = arguments[_key8];
      }

      return (_this$client4 = this.client)["delete"].apply(_this$client4, ["".concat(this.resourceUrl, "/").concat(intentionId)].concat(args));
    }
  }, {
    key: "getAudioSignedUrl",
    value: function getAudioSignedUrl(intentionId) {
      var _this$client5;

      for (var _len9 = arguments.length, args = new Array(_len9 > 1 ? _len9 - 1 : 0), _key9 = 1; _key9 < _len9; _key9++) {
        args[_key9 - 1] = arguments[_key9];
      }

      return (_this$client5 = this.client).get.apply(_this$client5, ["".concat(this.resourceUrl, "/").concat(intentionId, "/upload-signed-url")].concat(args));
    }
  }, {
    key: "updateAudioInsight",
    value: function updateAudioInsight(intentionId, insightId, data) {
      var _this$client6;

      for (var _len10 = arguments.length, args = new Array(_len10 > 3 ? _len10 - 3 : 0), _key10 = 3; _key10 < _len10; _key10++) {
        args[_key10 - 3] = arguments[_key10];
      }

      return (_this$client6 = this.client).put.apply(_this$client6, ["".concat(this.resourceUrl, "/").concat(intentionId, "/insight/").concat(insightId, "/update-file-name"), data].concat(args));
    }
  }, {
    key: "getInsightSignedUrl",
    value: function getInsightSignedUrl(intentionId, insightId) {
      var _this$client7;

      for (var _len11 = arguments.length, args = new Array(_len11 > 2 ? _len11 - 2 : 0), _key11 = 2; _key11 < _len11; _key11++) {
        args[_key11 - 2] = arguments[_key11];
      }

      return (_this$client7 = this.client).get.apply(_this$client7, ["".concat(this.resourceUrl, "/").concat(intentionId, "/insight/").concat(insightId, "/signed-url")].concat(args));
    }
  }]);
  return GrowthPlan;
}();

exports["default"] = GrowthPlan;